class RequestAjax {
    constructor() {
        this.HttpRequestResponse = {
            RESPONSE_RETURN_SUCCESS: 0,
            RESPONSE_RETURN_ERROR: 1,
            RESPONSE_NOT_SUPORT_RANGE: 2,
            RESPONSE_TIMEOUT: 3,
        };
        this.mxmlhttptemp = [];
    }
    sendRequest(requestType, responseType, url, timeout, startPos, endPos) {
        //发送请求
        let t = this;
        let response = this.HttpRequestResponse;
        return new Promise(function(resolve, reject) {
            let xmlhttp = null;
            xmlhttp = new XMLHttpRequest();
            if (xmlhttp == null || xmlhttp == undefined) {
                reject('notsupport');
            }
            t.mxmlhttptemp.push(xmlhttp); //保存请求，方便请求的取消
            xmlhttp.timeout = timeout; //设置超时
            if (responseType != null && responseType != undefined) {
                xmlhttp.responseType = responseType; //'arraybuffer'
            }

            xmlhttp.onreadystatechange = function() {
                if (this.readyState == 4) {
                    if (this.status == 200 || this.status == 206) {
                        let blobData = xmlhttp.response;
                        if (xmlhttp.status == 206 && (blobData == null || blobData == undefined)) {
                            resolve([response.RESPONSE_NOT_SUPORT_RANGE, requestType, xmlhttp, startPos, endPos]);
                        } else {
                            resolve([response.RESPONSE_RETURN_SUCCESS, requestType, xmlhttp, startPos, endPos]);
                        }
                    } else {
                        console.error('errorurl', url, this.status);
                        resolve([
                            response.RESPONSE_RETURN_ERROR,
                            requestType,
                            xmlhttp,
                            startPos,
                            endPos,
                            xmlhttp.status,
                        ]);
                    }
                    t.removeByValue(t.mxmlhttptemp, this);
                }
            };
            // 超时回调
            xmlhttp.ontimeout = function() {
                resolve([response.RESPONSE_TIMEOUT, requestType, xmlhttp, startPos, endPos]);
                t.removeByValue(t.mxmlhttptemp, this);
            };

            // 待联调
            let isRange = true;
            let rangeStr = 'range_bytes=';
            if (startPos != null) {
                if (startPos < 0) {
                    startPos = 0;
                }
                rangeStr += startPos + '-';
            } else {
                isRange = false;
            }

            if (endPos != null && endPos > startPos) {
                rangeStr += endPos;
            }

            if (isRange) {
                if (url.indexOf('?') > -1) {
                    url = url + '&' + rangeStr;
                } else {
                    url = url + '?' + rangeStr;
                }
            }

            xmlhttp.open(requestType, url, true);

            //todo待删除
            // let isRange = true;
            // let rangeStr = 'bytes=';
            // if (startPos != null) {
            //     if (startPos < 0) {
            //         startPos = 0;
            //     }
            //     rangeStr += startPos + '-';
            // } else {
            //     isRange = false;
            // }

            // if (endPos != null && endPos > startPos) {
            //     rangeStr += endPos;
            // }

            // if (isRange) {
            //     xmlhttp.setRequestHeader('Range', rangeStr);
            // }
            xmlhttp.send();
        });
    }
    removeByValue(arr, val) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i] == val) {
                arr.splice(i, 1);
                break;
            }
        }
    }
    stop() {
        for (let i = 0; i < this.mxmlhttptemp.length; i++) {
            this.mxmlhttptemp[i].abort(); //请求中止
        }
    }
    sendRequestJsonp(url, data) {
        let reqData = this.formatParams(data);
        let head = document.getElementsByTagName('head')[0];
        let script = document.createElement('script');
        script.setAttribute('src', url + '?' + reqData);
        script.onload = script.onreadystatechange = function() {
            if (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete') {
                head.removeChild(script);
            }
        };
        head.appendChild(script);
    }
    formatParams(data) {
        let arr = [];
        for (let name in data) {
            arr.push(encodeURIComponent(name) + '=' + encodeURIComponent(data[name]));
        }
        arr.push('v=' + this.random());
        return arr.join('&');
    }
    random() {
        return Math.floor(Math.random() * 10000 + 500);
    }
}

export default RequestAjax;



// WEBPACK FOOTER //
// ./components/f.component.mediasource/app/modules/httpRequest.js